import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import { getFacilityTypeLabel } from "@lib/logic";
import type { FacilityResource } from "@lib/store";
import { ModalCellItemIcon } from "@molecules";

type FacilityCellProps = {
  facility: FacilityResource;
};

/** A facility in the list and the carousel: its type's icon, its name, and its type and floor. */
export const FacilityCell = ({ facility }: FacilityCellProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const typeLabel = getFacilityTypeLabel(facility.data.facilityType, t);

  // A facility without a name of its own is named after its type, so the type isn't repeated under it
  const details = [typeLabel !== facility.name && typeLabel, facility.floorName].filter(Boolean).join(", ");

  return (
    <div className="flex min-w-0 items-start gap-3">
      <ModalCellItemIcon
        className="flex-none self-start"
        backgroundColor={theme.card.beige500.background}
        icon="toilet"
        iconUrl={facility.data.facilityType.lightIconUrl}
      />
      <div className="flex min-w-0 flex-col justify-center gap-0.5 pt-0.5">
        <p className="truncate font-semibold">{facility.name}</p>
        <p className="truncate text-mapiq-black-500">{details}</p>
      </div>
    </div>
  );
};
